import { RootState } from '@common/redux/store';

export const externalCollectionSelector = (state: RootState) =>
  state.externalCollection;
